import { FC } from 'react';
import { Alert, AlertTitle } from '@mui/material';

export const DeliveryAddressChangedNotice: FC = () => (
	<Alert
		severity="warning"
		variant="standard"
		sx={{
			mt: 2,
			fontSize: '.875rem',
			borderRadius: '12px',
			color: '#4a2c00',
			backgroundColor: '#ffe0b2',
			// border: '1px solid #ed6c02',
			// borderLeft: '1px solid #ed6c02',
			'& .MuiAlert-icon': { color: '#ed6c02' },
		}}
	>
		<AlertTitle sx={{ fontSize: '.875rem', fontWeight: 'bold', color: 'inherit' }}>
			The delivery address has been changed
		</AlertTitle>
		Please make sure you use the new address below. Parcels sent to the previous address (Mustamäe
		tee 50, Tallinn) may not be received.
		<br />
		<br />
		It is strictly required to add email and phone number when label is generated
	</Alert>
);
